import { createFileRoute } from '@tanstack/react-router'
import { StageDeliveryPage } from '@/lib/StageDeliveryPage'

export const Route = createFileRoute('/placements')({ component: PlacementsPage })

function PlacementsPage() {
  return <StageDeliveryPage stage="placement" title="Placements" subtitle="Roles that have been placed — the candidate is joining." />
}
